(() => {
  const routeNode = document.getElementById('KwebbelTCGRoutes');
  if (!routeNode) return;

  let routes = {};
  try { routes = JSON.parse(routeNode.textContent || '{}'); } catch (_) { return; }

  const normalize = (value = '') => value
    .toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const pathKey = (href = '') => {
    try {
      const url = new URL(href, window.location.origin);
      const parts = url.pathname.split('/').filter(Boolean);
      if (parts[0] === 'pages' || parts[0] === 'collections') return normalize(parts[1] || '');
    } catch (_) {}
    return '';
  };

  const resolve = (anchor) => {
    if (!(anchor instanceof HTMLAnchorElement)) return;
    if (anchor.hasAttribute('data-kwebbeltcg-no-rewrite')) return;
    const textKey = normalize(anchor.textContent || anchor.getAttribute('aria-label') || '');
    const hrefKey = pathKey(anchor.getAttribute('href') || '');
    const key = routes[textKey] ? textKey : hrefKey;
    if (key && routes[key]) anchor.setAttribute('href', routes[key]);
  };

  const scan = (root = document) => root.querySelectorAll?.('a[href]').forEach(resolve);

  const coreTcgLinks = [
    { key: 'pokemon', title: 'Pokémon', fallback: '/collections/pokemon' },
    { key: 'one-piece', title: 'One Piece', fallback: '/collections/one-piece' },
    { key: 'magic-the-gathering', title: 'Magic: The Gathering', fallback: '/collections/magic-the-gathering' },
  ];

  const coreKeys = new Set(coreTcgLinks.map((item) => normalize(item.title)));
  const isTcgMenuTitle = (value = '') => ['tcg-s', 'tcgs', 'alle-tcg-s', 'alle-tcgs'].includes(normalize(value));

  const createDesktopWrapper = (item) => {
    const wrapper = document.createElement('div');
    wrapper.dataset.kwebbeltcgCoreLink = item.key;

    const anchor = document.createElement('a');
    anchor.href = routes[item.key] || item.fallback;
    anchor.className = 'mega-menu__link';

    const label = document.createElement('span');
    label.className = 'wrap-text';
    label.textContent = item.title;

    anchor.append(label);
    wrapper.append(anchor);
    resolve(anchor);
    return wrapper;
  };

  const createMobileItem = (item) => {
    const li = document.createElement('li');
    li.className = 'menu-drawer__list-item';
    li.dataset.kwebbeltcgCoreLink = item.key;

    const anchor = document.createElement('a');
    anchor.href = routes[item.key] || item.fallback;
    anchor.className = 'menu-drawer__menu-item menu-drawer__menu-item--child focus-inset';

    const label = document.createElement('span');
    label.className = 'menu-drawer__menu-item-text wrap-text';
    label.textContent = item.title;

    anchor.append(label);
    li.append(anchor);
    resolve(anchor);
    return li;
  };

  const orderDesktopMenu = (menuItem) => {
    const list = menuItem.querySelector(':scope > .menu-list__submenu .mega-menu__list');
    if (!list) return;

    let columns = Array.from(list.children).filter((child) => child.classList?.contains('mega-menu__column'));
    let targetColumn = columns[0];

    if (!targetColumn) {
      targetColumn = document.createElement('li');
      targetColumn.className = 'mega-menu__column mega-menu__column--span-1';
      list.prepend(targetColumn);
      columns = [targetColumn];
    }

    const allWrappers = columns.flatMap((column) =>
      Array.from(column.children).filter((child) => child.tagName === 'DIV')
    );

    const coreWrappers = new Map();
    const remainingWrappers = [];

    allWrappers.forEach((wrapper) => {
      const anchor = wrapper.querySelector(':scope > a.mega-menu__link');
      const titleKey = normalize(anchor?.textContent || '');
      const coreItem = coreTcgLinks.find((item) => normalize(item.title) === titleKey);

      if (coreItem && !coreWrappers.has(coreItem.key)) {
        coreWrappers.set(coreItem.key, wrapper);
        anchor.href = routes[coreItem.key] || coreItem.fallback;
        resolve(anchor);
      } else if (!coreKeys.has(titleKey)) {
        remainingWrappers.push(wrapper);
      }
    });

    coreTcgLinks.forEach((item) => {
      if (!coreWrappers.has(item.key)) coreWrappers.set(item.key, createDesktopWrapper(item));
    });

    const desiredWrappers = [
      ...coreTcgLinks.map((item) => coreWrappers.get(item.key)),
      ...remainingWrappers,
    ];

    desiredWrappers.forEach((wrapper, index) => {
      const current = targetColumn.children[index];
      if (current !== wrapper) targetColumn.insertBefore(wrapper, current || null);
    });

    targetColumn.className = 'mega-menu__column mega-menu__column--span-1';

    columns.forEach((column) => {
      if (column !== targetColumn) column.remove();
    });
  };

  const orderMobileMenu = (menuItem) => {
    const list = menuItem.querySelector('ul.menu-drawer__menu--childlist');
    if (!list) return;

    const allItems = Array.from(list.children).filter((child) => child.tagName === 'LI');
    const coreItems = new Map();
    const remainingItems = [];

    allItems.forEach((li) => {
      const anchor = li.querySelector(':scope > a');
      const titleKey = normalize(anchor?.textContent || '');
      const coreItem = coreTcgLinks.find((item) => normalize(item.title) === titleKey);

      if (coreItem && !coreItems.has(coreItem.key)) {
        coreItems.set(coreItem.key, li);
        anchor.href = routes[coreItem.key] || coreItem.fallback;
        resolve(anchor);
      } else if (!coreKeys.has(titleKey)) {
        remainingItems.push(li);
      }
    });

    coreTcgLinks.forEach((item) => {
      if (!coreItems.has(item.key)) coreItems.set(item.key, createMobileItem(item));
    });

    const desiredItems = [
      ...coreTcgLinks.map((item) => coreItems.get(item.key)),
      ...remainingItems,
    ];

    desiredItems.forEach((li, index) => {
      const current = list.children[index];
      if (current !== li) list.insertBefore(li, current || null);
    });
  };

  const ensureCoreTcgMenuLinks = () => {
    document.querySelectorAll('.header-menu .menu-list__list-item').forEach((menuItem) => {
      const topLink = menuItem.querySelector(':scope > a.menu-list__link');
      if (topLink && isTcgMenuTitle(topLink.textContent)) orderDesktopMenu(menuItem);
    });

    document.querySelectorAll('.menu-drawer__menu > .menu-drawer__list-item, .menu-drawer__menu > li').forEach((menuItem) => {
      const topControl = menuItem.querySelector(':scope > a, :scope > details > summary');
      if (topControl && isTcgMenuTitle(topControl.textContent)) orderMobileMenu(menuItem);
    });
  };

  scan();
  ensureCoreTcgMenuLinks();

  new MutationObserver((entries) => {
    for (const entry of entries) {
      for (const node of entry.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.('a[href]')) resolve(node);
        scan(node);
      }
    }
    ensureCoreTcgMenuLinks();
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', (event) => {
    const anchor = event.target.closest?.('a[href]');
    if (anchor) resolve(anchor);
  }, true);
})();
